import styled from 'styled-components';

const HIGHLIGHT_GREEN = '#10a875';
const BENEFIT_ICON_BG = '#d1fae5';

export const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 729fr) minmax(0, 471fr);
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  line-height: 1.2;
  letter-spacing: -0.32px;
  color: #000;
  border: 1px solid ${(props) => props.theme.$gray400};
  border-radius: 16px;

  @media (max-width: 767.98px) {
    grid-template-columns: 1fr;
  }

  .upsell-main {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
    background-color: ${(props) => props.theme.$white};
  }

  .upsell-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }

  .upsell-logo {
    width: auto;
    height: 32px;
  }

  .btn-dashboard {
    padding: 16px;
    font-size: 16px;
    color: ${(props) => props.theme.$primary};
  }

  .upsell-headline {
    margin: 0;
    font-size: 32px;
    font-weight: 700;
    letter-spacing: 0;
    color: ${(props) => props.theme.$dark};

    strong {
      color: ${HIGHLIGHT_GREEN};
    }
  }

  .upsell-text {
    margin: 0;
  }

  .upsell-benefits {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .benefit-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border-radius: 2.5px;
    background-color: ${BENEFIT_ICON_BG};
  }

  .upsell-actions {
    display: flex;
    gap: 24px;

    .btn {
      flex: 1 1 0;
      padding: 16px;
      font-size: 16px;
      line-height: 1.2;
      border-radius: 4px;
    }

    @media (max-width: 767.98px) {
      flex-direction: column;
      gap: 8px;
    }
  }

  .btn-trial {
    color: ${(props) => props.theme.$white};
    background-color: ${(props) => props.theme.$primary};
    border-color: ${(props) => props.theme.$primary};

    &:hover,
    &:focus {
      color: ${(props) => props.theme.$white};
    }
  }

  .btn-plans {
    color: ${(props) => props.theme.$primary};
  }

  .upsell-aside {
    display: flex;
    flex-direction: column;
    gap: 48px;
    padding: 24px;
    background-color: ${(props) => props.theme.$gray200};
  }

  .aside-header {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .aside-summary {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${(props) => props.theme.$gray400};
  }

  .aside-count {
    font-size: 32px;
    font-weight: 700;
    letter-spacing: 0;
    color: ${HIGHLIGHT_GREEN};
  }

  .portal-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 161px));
    justify-content: center;
    gap: 8px 24px;
  }

  .portal-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 10px;
    background-color: ${(props) => props.theme.$white};
    border-radius: 4px;

    img {
      max-width: 100%;
      max-height: 36px;
      object-fit: contain;
    }
  }
`;
